const messages = {
  information: 'Information',
  close: 'Schließen',
  changeRequest: 'Änderungsvorschlag',
  status: 'Status',
  date: 'Datum',
  recruitmentStatus: 'Rekrutierungsstatus',
  wildtype: 'Wildtyp',
  mutated: 'Alteration',
  result: 'Ergebnis',
  results: 'Ergebnisse',
  logout: 'Abmelden',
  langAbbrev: 'de',
  yes: 'ja',
  no: 'nein',
  foundStudies: 'Gefundene Studien',
  favourites: 'Favoriten',
  impressum: 'Impressum',
  privacyStatement: 'Datenschutzerklärung',
  // Short label for the privacy link, used in the footer below the mobile
  // breakpoint where the full label does not fit
  privacyStatementShort: 'Datenschutz',
  osmAttribution:
    'Geographische Informationen (Koordinaten): © OpenStreetMap-Mitwirkende',
  hiddenOnes: 'Archivierte',
  visibleOnes: 'Normal',
  all: 'Alle',
  validated: 'Validiert',
  notValidated: 'Nicht validiert',
  reqRevalid: 'Erneute Validierung nötig',
  select: 'Auswählen',
  noStudiesFound: 'Keine Studien gefunden',
  noStudiesInFavourites: 'Keine Studien in der Favoritenliste',
  back: 'Zurück',
  edit: 'Bearbeiten',
  city: 'Stadt',
  state: 'Bundesland',
  country: 'Land',
  save: 'Speichern',
  cancel: 'Abbrechen',
  apply: 'Übernehmen',
  hidden: 'archiviert',
  visible: 'normal (nicht archiviert)',
  author: 'Autor',
  of: 'von',
  unknown: 'unbekannt',
  district: 'Gebiet',
  confirm: 'Bestätigen',
  user: 'Nutzer',
  role: 'Rolle',
  inclusion: 'Einschluss',
  exclusion: 'Ausschluss',
  andMore: '... und weitere',
  and: 'und',
  or: 'oder',
  around: 'um',
  clickConfirmToApplyChanges:
    'Um Bestätigungen wirksam zu machen, bitte auf "Änderungen übernehmen" in der oberen Leiste klicken',
  manageTrackingConsent: 'Cookie-Zustimmung verwalten',
  topMenuBox: {
    newStudy: 'Neue Studie erstellen',
    favorites: 'Favoriten',
    allStudies: 'Studienübersicht',
    changeRequests: 'Änderungsvorschläge',
    myChangeRequests: 'Meine Änderungsvorschläge',
    patientDocs: 'CATS Anleitung',
  },
  tableView: {
    adaptTableColumns: 'Tabellenansicht anpassen',
    tableViewTooltip:
      'Bestimmt welche Spalten in der Studientabelle angezeigt werden.',
    resultsPerPage: 'pro Seite',
    resetTooltip: 'Setzt die Ansicht auf die Standardauswahl zurück',
    modalTitle: 'Tabellenansicht',
    modalInfoText:
      'Bitte wählen Sie die Spalten aus, die angezeigt werden sollen',
    reset: 'Zurücksetzen',
    deselectAll: 'Alle abwählen',
    selectAll: 'Alle auswählen',
    done: 'Fertig',
    chooseOneTooltip: 'Bitte wählen Sie mindestens eine Spalte aus',
    useBriefTitle: 'Kurze Studientitel anzeigen',
    useOfficialTitle: 'Offizielle Studientitel anzeigen',
  },
  trialsList: {
    searchErrorTitle: 'Suche fehlgeschlagen',
    searchErrorText:
      'Die Studienliste konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
    titleSearchInfoText:
      'Die Eingabe wird in offiziellen und Kurztiteln gesucht',
    titleSearchInfoTooltip:
      'Wenn der gesuchte Text nicht angezeigt wird, wechseln Sie die Titelansicht',
    openSourceInNewTab: 'Quellseite in neuem Tab öffnen',
    tumorcategory: 'Tumorkategorie',
    searchInputPlaceholder: 'In Titeln suchen...',
    title: 'Titel',
    briefTitle: 'Kurztitel',
    originalTitle: 'Originaltitel',
    officialTitle: 'Offizieller Titel',
    subtype: 'Subtyp',
    geneWild: 'Gen (Wildtyp)',
    geneMutated: 'Gen (Verändert)',
    variant: 'Variante',
    lineOfTherapy: 'Therapielinie',
    tmb: 'Mutationslast',
    locations: 'Orte',
    lastChange: 'Letzte Änderung',
    validated: 'Validiert',
    diagnose: 'Diagnose',
    diagnoses: 'Diagnosen',
    adjuvant: 'Adjuvant',
    biomarker: 'Biomarker',
    pathway: 'Pathway',
    tumorentity: 'Tumorentität',
    tumorregion: 'Tumorregion',
    uicc: 'UICC',
    intervention: 'Intervention',
    addToFavouritesShort: 'Studie zu Favoriten hinzufügen',
    addToFavourites: 'Studie zur Liste gespeicherter Studien hinzufügen',
    studyAddedToFavourites: 'Studie zur persönlichen Liste hinzugefügt',
    removeStudyFromFavourites:
      'Studie aus Liste gespeicherter Studien entfernen',
    removeStudyFromFavouritesShort: 'Studie aus Favoriten entfernen',
    removedStudyFromFavourites: 'Studie von persönlicher Liste entfernt',
    copiedStudySourceLinkToClipboard:
      'Link zur Studie im Quellsystem in die Zwischenablage kopiert',
    copiedSearchLinkToClipboard: 'Link zur Suche in die Zwischenablage kopiert',
    copiedLink: 'Link kopiert',
    checkedAndValidated: 'Studie wurde geprüft und validiert',
    needsRevalidation:
      'Studie wurde validiert und anschließend bearbeitet, erneute Validierung ist nötig',
    studyNotChangedThreshold:
      'Diese Studie wurde seit mindestens 30 Tagen nicht verändert',
    studyNotValidated:
      'Studie wurde noch nicht validiert. Die Informationen sind möglicherweise unzuverlässig und/oder unvollständig',
    sortingToolTip:
      'Klicken schaltet zwischen auf- und absteigender Sortierung um.',
    titleToggleTooltip:
      'Zwischen offiziellem und Kurztitel umschalten. Ist für eine Studie kein Kurztitel angegeben, wird stattdessen der offizielle Titel angezeigt.',
  },
  filter: {
    filterProfiles: {
      modal: {
        saveFilterProfileModalTitle: 'Suchprofil speichern',
        saveFilterProfileModalMessage:
          'Speichert die aktuelle Suche zur späteren Wiederverwendung. Falls Sie keinen Namen eingeben, wird das aktuelle Datum und die Zeit als Name verwendet.',
        saveFilterProfileModalMessageEnterDifferentName:
          'Bitte geben Sie einen anderen Namen für das Filterprofil an. Der zuvor gewählte existiert bereits.',
        inputPlaceholder: 'Profilname',
      },
      dropdownBtnLabel: 'Gespeicherte Suchen',
      tooltips: { deleteProfile: 'Filterprofil löschen' },
      filterProfileTable: {
        remove: 'Entfernen',
        name: 'Profil',
      },
    },
    activeFilters: 'Aktive Filter',
    collapseActiveFilters: 'Aktive Filter einklappen',
    expandActiveFilters: 'Aktive Filter ausklappen',
    filterCategoryTabs: {
      general: 'Allgemein',
      clinical: 'Klinisch',
      genetic: 'Genetisch',
    },
    biomarkerPopupOpenBtnText: 'Biomarker auswählen',
    exclusionCriterionTagTooltip: 'Ausschlusskriterium',
    inclusionCriterionTagTooltip: 'Einschlusskriterium',
    advancedSearch: 'Fortgeschrittene Suche',
    standardSearch: 'Standardsuche',
    excludeSetByParentCategory:
      'Dieser Diagnosefilter wurde automatisch durch die Auswahl einer Diagnosekategorie (z.B. Tumorentität) erstellt. Ob es sich um ein Ein- oder Ausschlusskriterium handelt wird durch den Status der Diagnosekategorie bestimmt, weshalb dieses Auswahlfeld deaktiviert ist.',
    filterTags: {
      expandBtnText: 'mehr anzeigen',
      collapseBtnText: 'weniger anzeigen',
      showHiddenStudies: 'Sichtbarkeit',
      onlyHidden: 'Nur archivierte',
      all: 'Alle',
      showValidatedStudies: 'Validierung',
      onlyNonValidated: 'Nur nicht validierte',
      onlyValidated: 'Nur validierte',
      onlyReqRevalid: 'Nur erneut zu validierende',
      locationName: 'Einrichtung',
      location: 'Ort',
    },
    showOnlyGeneticallyStratifiedTrialsFilterTag:
      'Genetisch stratifizierte Studien',
    showOnlyGeneticallyStratifiedTrials:
      'Nur genetisch stratifizierte Studien anzeigen',
    showOnlyGeneticallyStratifiedTrialsTooltip:
      'Nur Studien anzeigen, die mit mindestens einem alterierten Gen oder einer Variante annotiert sind',
    proteinChange: 'Protein Change',
    proteinChangePlaceholder: 'z.B. V600E',
    autoCreatedBySelectionOf: 'Automatisch erstellt durch Auswahl von',
    removeParentCategoryTooltip:
      'Kann mehrere Diagnosen umfassen. Entfernen dieser Kategorie entfernt auch alle durch sie automatisch hinzugefügten Diagnosen. Diese sind entsprechend gekennzeichnet.',
    showFilterOptions: 'Filteroptionen anzeigen',
    hideFilterOptions: 'Filteroptionen ausblenden',
    resetFilter: 'Filter zurücksetzen',
    filterOptions: 'Filteroptionen',
    mainFilterTooltip: `Bei Auswahl mehrerer Filter derselben Kategorie (z.B. "Beteiligte
Einrichtungen") werden diese entweder mit dem logischen "ODER"
oder mit dem logischen "UND" verknüpft. Die Verknüpfung zwischen
Kategorien ist immer "UND" (z.B. (Filterkriterien für Status) *und* (Filterkriterien für Beteiligte Einrichtungen)).  
Logische Verknüpfung: Durch "ODER" verknüpfte Werte werden
zusammen gruppiert.

Beispiel: A  *und* (B oder C)
 *und* D. Um durch "UND" getrennte Variablen zusammen
gruppieren zu können (Beispiel: (A  *und* B)
 *oder* C), geben Sie sie so ein: Beispiel: (A
 *oder* C)  *und* (B  *oder* C)

Erklärung für **Kriterium A "UND" Kriterium B**: Eine Studie muss sowohl
Kriterium A, als auch Kriterium B erfüllen, um gefunden zu werden.  
Erklärung für **Kriterium A "ODER" Kriterium B**: Eine Studie muss
Kriterium A oder Kriterium B (oder beide) erfüllen, um gefunden zu
werden.`,
    mainFilterTooltipSimplified: `Bei Auswahl mehrerer Filter derselben Kategorie (z.B. "Beteiligte
Einrichtungen") werden alle passenden Ergebnisse angezeigt, die mindestens einem dieser Filter entsprechen.

Bei Auswahl mehrerer Filter verschiedener Kategorien (z.B. (Filterkriterien für Beteiligte Einrichtungen) und (Filterkriterien für Diagnosen))
werden nur die Ergebnisse angezeigt, die zu allen ausgewählten Kategorien passen.`,
    saveFilterPofileTooltip:
      'Die gerade gesetzten Filter werden als Filterprofil gespeichert, das später schnell und einfach wieder angewendet werden kann',
    filterModeTooltip: `Die **Standardsuche** unterstützt schnelle und strukturierte
Eingabe von Suchkriterien. Alle eingegebenen Kriterien werden als _Einschlusskriterien_ interpretiert.

Die **fortgeschrittene Suche** bietet dagegen flexiblere
Eingabemöglichkeiten und unterstützt somit komplexere
Abfragen.`,
    generalCriteria: 'Allgemeine Filterkriterien',
    generalCriteriaPatientView: 'Standortbasierte Suche',
    simpleModeTooltip: `Eingegebene allgemeine Filterkriterien werden
          untereinander automatisch mit dem logischen "ODER" verknüpft.`,
    patientModeTooltip: 'Standortbasierte Filterkriterien',
    hiddenCriteriaTooltip: `Als nicht relevant markierte Studien werden
          normalerweise nicht angezeigt ("archiviert"). Sollen
          dennoch alle oder auch nur archivierte Studien angezeigt
          werden, kann dies hier eingestellt werden.`,
    hiddenCriterionTitle: 'Stu&shy;di&shy;en an&shy;zei&shy;gen',
    openAdvancedSearch: 'Zur fortgeschrittenen Suche',
    saveFilterProfile: 'Filterprofil speichern',
    openSimpleSearch: 'Zur Standardsuche',
    validationStatus: 'Va&shy;li&shy;die&shy;rungs&shy;sta&shy;tus',
    validationStatusTooltip: `Manche Studien wurden noch nicht validiert und müssen
          daher noch überprüft werden. Dies kann beispielsweise
          der Fall sein, wenn eine Studie automatisiert zur
          Datenbank hinzugefügt wurde. Nach solchen Studien kann
          hier gesucht werden.`,
    statusTooltip: `Nach Studienstatus filtern. Bei Auswahl mehrerer
Optionen werden diese mit "ODER" verknüft.

Beispiel: "Recruiting"  *oder* "Active not recruiting"`,
    locations: 'Stu&shy;di&shy;en&shy;stand&shy;or&shy;te',
    facilities: 'Be&shy;tei&shy;lig&shy;te Ein&shy;rich&shy;tung&shy;en',
    locationsTooltipSimple: 'Nach Namen der beteiligten Einrichtungen filtern.',
    locationsTooltipAdvanced: `Nach Namen der beteiligten Einrichtungen filtern.
        Bei Auswahl mehrerer Optionen werden diese wahlweise mit "ODER" oder "UND" verknüft.`,
    facilitiesTooltipSimple: 'Nach beteiligten Städten filtern.',
    facilitiesTooltipAdvanced: `Nach Orten (Städteauswahl oder Freitextsuche) filtern.
      Bei Auswahl mehrerer Optionen werden diese wahlweise mit "ODER" oder "UND" verknüft`,
    facilityNamePlaceholder: 'Name der Einrichtung',
    selectCityPlaceholder: 'Stadt auswählen',
    identifierPlaceholder: 'Studienidentifier z.B. NCT12345678',
    identifierTooltip: `Eine Studie mit ihrem Identifier suchen. Die Eingabe
    muss exakt mit dem Identifier übereinstimmen.`,
    identifierImportButton: 'Studie importieren',
    clinicalFilterCriteria: 'Klinische Einschlusskriterien',
    clinicalFilterCriteriaTooltip: `Nach klinischen Eigenschaften der untersuchten Gruppen filtern. Bei
    Auswahl mehrerer Optionen werden diese mit "UND" verknüft. Eine Ausnahme von dieser Regel stellt die Kategorie 'Diagnose' dar, deren Werte mit "ODER" verknüpft werden`,
    clinicalFilterCriteriaTooltipSimplified:
      'Nach klinischen Eigenschaften der untersuchten Gruppen filtern. Mit Ausnahme von Diagnosen werden mehrere Filter derselben Kategorie so verknüpft, dass Ergebnisse zu allen ausgewählten Filtern passen.',
    diagnose: 'Di&shy;ag&shy;no&shy;se',
    intervention: 'In&shy;ter&shy;ven&shy;tion',
    subtype: 'Sub&shy;typ',
    tumorentity: 'Tu&shy;mor&shy;en&shy;ti&shy;tät',
    tumorregion: 'Tu&shy;mor&shy;reg&shy;ion',
    tumorcategory: 'Tu&shy;mor&shy;ka&shy;te&shy;go&shy;rie',
    tumorregionPlaceholder: 'z.B. Pankreas',
    tumorcategoryPlaceholder: 'z.B. Solide Tumore',
    tumorentityPlaceholder: 'z.B. Bindegewebe',
    biomarkerPlaceholder: 'z.B. EBV',
    uiccPlaceholder: 'z.B. IA',
    subtypePlaceholder: 'z.B. GIST',
    interventionPlaceholder: 'z.B. Cisplatin',
    diagnosePlaceholder: 'z.B. C25 - Bösartige Neubildung des Pankreas',
    clinicalAndGeneticCriteria: 'Klinische und Genetische Filterkriterien',
    clinicalAndGeneticCriteriaTooltip: `Nach Eigenschaften der untersuchten Gruppen filtern. Bei
    Auswahl mehrerer Optionen werden diese nach Wahl mit "UND"
    oder mit "ODER" verknüft.`,
    geneticCriteria: 'Genetische Einschlusskriterien',
    geneticCriteriaTooltip: `Nach Eigenschaften der untersuchten Gruppen filtern. Bei
    Auswahl mehrerer Optionen werden diese mit "UND" verknüft.`,
    geneWild: 'Gen (Wild&shy;typ)',
    genePlaceholder: 'z.B. BRCA1',
    geneMutated: 'Gen (Ver&shy;än&shy;dert)',
    tmb: 'Tu&shy;mor&shy;mu&shy;ta&shy;tions&shy;last',
    tmbPlaceholder: 'z.B. medium',
    lineOfTherapy: 'The&shy;ra&shy;pie&shy;li&shy;nie',
    lineOfTherapyPlaceholder: 'z.B. 2',
    adjuvantPlaceholder: 'ja/nein',
    changeCategory: 'Kategorie auswählen',
    pathway: 'Pathway',
    biomarker: 'Biomarker',
    uicc: 'UICC',
    adjuvant: 'Adjuvant',
    perimeterSearch: 'Umkreis',
    geolocationTooltipTooltip:
      'Auf Basis Ihrer oder einer anderen ausgewählten Position können auf Wunsch nur Studien angezeigt werden, die eine gewisse Entfernung zu dieser Position nicht überschreiten.',
    locateMe: 'Orte mich',
    myCoordinates: 'Meine Koordinaten',
    lat: 'Längengrad',
    lon: 'Breitengrad',
    advancedFunctionalityNotCompleteWarning:
      'Vorsicht bei der Nutzung der fortgeschrittenen Suche. Die volle Funktionalität ist derzeit nicht verfügbar und bei der Verwendung von Gen-Filtern (Alteration / Wildtyp) sind die Ergebnisse nicht verlässlich. Sollten Probleme oder Unsicherheiten auftreten, benutzen Sie für den Moment bitte die Standardsuche.',
    variantPlaceholder: 'Variante',
  },
  tmb: { high: 'Hoch', medium: 'Mittel', low: 'Niedrig' },
  settings: {
    changeHistoryColSelectionHeader: 'Änderungshistorie',
    changeHistoryColSelectionTooltip:
      'Wählen Sie aus, welche Spalten die Tabelle für die Änderungshistorie in der Detailansicht zeigen soll',
    changeHistoryColSelectionExplMsg:
      'Individuelle Auswahl der angezeigten Informationen',
    fontSizeAdjustMsg: 'Schriftgröße',
    fontSizeAdjustTooltip: `Die Einstellung der Schriftgröße beeinflusst auch die Größe großer
    Teile des Webtools. Das Layout kann deshalb unter größeren
    Änderungen der Schriftgröße leiden.`,
    fontSizeAdjustExplMsg: 'Textdarstellung anpassen',
    fontSizeExampleText:
      'Beispieltext: An diesem Text können Sie die Änderungen der Schriftgröße sehen.',
    fontSize: 'Schriftgröße',
    settings: 'Einstellungen',
    small: 'Klein',
    normal: 'Standardgröße',
    medLarge: 'Mittelgroß',
    large: 'Groß',
  },
  details: {
    patientView: {
      studyDetails: 'Untersuchungsdetails',
      contactInformation: 'Kontaktinformationen',
      mutatedGenes: 'Veränderte Gene',
      interventions: 'Interventionen',
      diagnoses: 'Diagnosen',
      studyLocations: 'Beteiligte Einrichtungen',
      tooltips: {
        contactsEmptyDisabled: 'Keine Kontaktinformationen verfügbar',
        locationsEmptyDisabled:
          'Keine Informationen zu beteiligten Einrichtungen verfügbar',
      },
    },
    archiveInfo:
      'Das Archivieren einer Studie betrifft alle Benutzer. Archivierte Studien erscheinen nicht mehr in der normalen Studienliste, können aber über den entsprechenden Filter weiterhin gefunden werden.',
    groupNamePlaceholder: 'Kohortenbezeichnung',
    saveErrorMsg:
      'Änderungen konnten aufgrund eines Fehlers nicht gespeichert werden. Weitere Informationen finden Sie in der Konsole. Wenden Sie sich ggf. mit einer Problembeschreibung an das CATS Team.',
    titleInfoModal: {
      chooseTitle: 'Titel auswählen',
      enterTitle:
        'Leere Titel sind nicht gültig. Bitte geben Sie einen Titel ein.',
    },
    recruitmentStatusIndicator: {
      tooltips: {
        recruiting: 'Patienten werden aufgenommen',
        caution:
          'Patienten werden unter gewissen Umständen bzw nicht uneingeschränkt aufgenommen',
        notRecruiting: 'Es werden keine Patienten aufgenommen',
        unknown: 'Rekrutierungsstatus unbekannt',
      },
    },
    recruitmentStatusSelector: {
      tooltips: {
        recruiting: 'Nur rekrutierende Einrichtungen anzeigen',
        caution: 'Nur Einrichtungen mit eingeschränkter Rekrutierung anzeigen',
        notRecruiting: 'Nur Einrichtungen anzeigen, die nicht rekrutieren',
        unknown:
          'Nur Einrichtungen mit unbekanntem Rekrutierungsstatus anzeigen',
        clickAgainToDeselect: 'Tipp: Zum Abwählen erneut klicken',
      },
    },
    facilityStatusFilterLabel: 'Statusfilter',
    changeHistorySummary: {
      affectedField: 'Betroffener Bereich',
      kindOfChange: 'Art der Änderung',
      newValue: 'Neuer Wert',
      user: 'Nutzer',
      changeReason: 'Änderungsgrund',
      changeConfirmed: 'Änderung bestätigt',
      contact: 'Kontakt',
      site: 'Beteiligte Einrichtung',
      manual: 'Manuell',
      automatic: 'Maschinell',
      kindOfChangeShort: 'Art',
      newValueShort: 'Neu',
      changeReasonShort: 'Grund',
      changeConfirmedShort: 'Validiert',
      newSiteSuffix: 'Neue Einrichtung',
      confirmChangeBtnText: 'Validieren',
      removeConfirmationBtnText: 'Validierung entfernen',
    },
    studyInfoLastChangedOn: 'Studieninformation zuletzt geändert am',
    groupInfoLastChangedOn: 'Kohorteninformation zuletzt geändert am',
    geneticInformation: 'Genetische Information',
    chooseAction: 'Aktion auswählen',
    adjuvant: {
      adjuvantTrue: 'Adjuvant',
      adjuvantFalse: 'Nicht adjuvant',
    },
    tryingToOpenDetailsWithInvalidChangeRequest:
      'Detailansicht mit ungültigem Änderungsvorschlag geladen',
    shareStudyBtn: 'Studie teilen',
    shareStudyBtnToast: {
      successTitle: 'Link kopiert',
      successMessage:
        'Der Link zu dieser Seite wurde in die zwischenablage kopiert',
      failureTitle: 'Etwas ist schief gegangen',
      failureMessage:
        'Der Link zur Studienseite konnte nicht in die Zwischenablage kopiert werden. Weitere Informationen finden sich evtl in der Konsolenausgabe..',
    },
    applyChangeRequestToast: {
      success: {
        title: 'Übernommen',
        message: 'Die vorgeschlagene Änderung wurde automatisch übernommen.',
      },
      failure: {
        title: 'Etwas ist schief gelaufen',
        message:
          'Die vorgeschlagene Änderung konnte nicht automatisch übernommen werden. Bitte versuchen Sie es später erneut oder kontaktieren Sie den Support, falls das Problem weiterhin besteht.',
      },
    },
    variant: 'Variante',
    newInterventionNotProcessed:
      'Neue Intervention konnte nicht korrekt verarbeitet werden.',
    chooseValidationTag: 'Validierungsstatus auswählen',
    undoValidation: 'Invalidieren',
    validate: 'Validieren',
    reqRevalid: 'Erneute Validierung nötig',
    discardChanges: 'Änderungen verwerfen',
    applyChanges: 'Speichern',
    applyChangesDisabled:
      'Speichern nicht möglich, überprüfen Sie Ihre Eingaben auf Fehler',
    fetchExistingTrial:
      'Eine bestehende Studie von clinicaltrials.gov übernehmen',
    enterIdentifierTooltip:
      'Bitte geben Sie einen NCT-Identifier der Form NCTxxxxxxxx (acht Zahlen) ein.',
    createByIdentifierTooltip: `Studie mit passendem Identifier suchen und hinzufügen.`,
    generalInfo: 'Allgemeine Informationen',
    editChangeReason: 'Änderungsgrund bearbeiten',
    entryBeforeChange: 'Eintrag vor der Änderung',
    entryHasBeenNewlyAdded: 'Eintrag wurde neu angelegt',
    searchAvailableSystems: 'Nach verfügbaren Systemen suchen',
    additionalInfo: 'Zusätzliche Informationen',
    noAdditionalInfoEntered: 'Keine zusätzlichen Informationen eingegeben',
    studyVisibility: 'Sichtbarkeit der Studie',
    studyHidden: 'Die Studie ist archiviert',
    studyVisible: 'Die Studie ist sichtbar (nicht archiviert)',
    studyIs: 'Die Studie ist',
    studyHiddenCommentLabel: 'Kommentar',
    studyInfoLastChanged: 'Studieninformation zuletzt geändert',
    additionalInfoTooltip:
      'Zusätzliche Informationen zur Studie. Beim Hinzufügen eines neuen Eintrags oder Ändern eines bestehenden Eintrags wird der aktuelle Benutzer als Autor gespeichert.',
    identifierChangeTooltip:
      'Bestehende Identifier können nur von besonders befugten Nutzern korrigiert werden. Bei Fragen wenden Sie sich bitte an den Support.',
    catsIdentifierToolTip:
      'Der CATS-Identfier kann nicht verändert werden, da dieser automatisch erstellt wird.',
    titleChangeTooltip:
      'Titel können nur von besonders befugten Nutzern geändert werden. Bei Fragen wenden Sie sich bitte an den Support.',
    copyLinkToClipboard: 'Link in Zwischenablage kopieren',
    copyIdentToClipboard: 'Identifier in Zwischenablage kopieren',
    copyidentToClipboardToastTitle: 'Identifier kopiert',
    copyidentToClipboardToastMsg:
      'Studien Identifier erfolgreich in Zwischenablage kopiert',
    examinationDetails: 'Klinischer Fokus',
    trialDetails: 'Details zur Studie',
    conditionFocusTooltip:
      'Zusammenfassung aller Diagnosen und Interventionen aller Studiengruppen / Kohorten',
    characteristicAiTooltip:
      'Diese Information wurde mithilfe von KI hinzugefügt, eine Validierung ist nötig.',
    characteristicAliasesTooltip: 'Alternative Namen (Aliase) dieses Konzepts',
    diagnoseTooltip:
      'Hier werden die Diagnosen aller untersuchten Gruppen zusammengefasst',
    interventions: 'Interventionen',
    interventionsTooltip:
      'Hier werden die Interventionen aller untersuchten Gruppen zusammengefasst',
    involvedFacilities: 'Beteiligte Einrichtungen',
    locationTooltipEditMode: `
Um eine Einrichtung **hinzuzufügen**: Namen in die Suchleiste
eintragen und passenden Eintrag auswählen. Dieser wird zur Liste
hinzugefügt. Vorgang wiederholen, um mehrere Einrichtungen
hinzuzufügen.

Um eine Einrichtung **neu zu erstellen**: Falls die
gewünschte Einrichtung nicht in der Auswahl auftaucht, bitte auf
"neue Einrichtung anlegen" im Dropdown-Menü (erscheint bei Klick
auf die Suchleiste) klicken.

Um eine Einrichtung zu **löschen**: Das Mülleimer-Symbol im
entsprechenden Eintrag anklicken.`,
    enterFacilityNameSearch: 'Namen einer Einrichtung eingeben, um zu suchen',
    enterToSearch: 'Text eingeben, um zu suchen',
    addFacility: 'Eine Einrichtung hinzufügen',
    createFacility: 'Neue Einrichtung anlegen',
    location: 'Standort',
    receivedStatus: 'Übermittelter Status',
    userStatus: 'Annotierter status',
    searchStatus: 'Nach Status suchen',
    cohortDetails: 'Kohortendetails',
    addCohort: 'Kohorte hinzufügen',
    removeCohort: 'Kohorte entfernen',
    cohort: 'Kohorte',
    subtypes: 'Subtypen',
    genesWild: 'Gene (Wildtyp)',
    genesMutated: 'Genetische Alteration',
    tmb: 'Tumormutationslast',
    cohortLastChanged: 'Kohorteninformation zuletzt geändert',
    deleteStudy: 'Studie löschen',
    id: 'ID-Nummer',
    commentPlaceholder: 'Kommentar',
    noInfo: 'Keine Angaben',
    noDataAvailable: 'Keine Daten vorhanden',
    furtherCategoriesWithoutData: 'Weitere Kategorien ohne Daten: {count}',
    openMapTooltip: 'Auf Karte ansehen',
    defaultEmptyName: 'Keine Angabe',
    diagnosePlaceholder: 'Diagnosen nach icd10',
    ctStatusTooltip:
      'Dieser Status wird automatisch von clinicaltrials.gov übernommen und kann nicht manuell bearbeitet werden',
    userStatusTooltip:
      'Dieser Status wird von Nutzern eingetragen und kann sich vom maschinell übernommenen Status unterscheiden',
    changeReasonTooltip:
      'Um die Änderungen aus diesem Dialogfenster wirksam zu machen, muss die Studie nach der Bearbeitung erneut gespeichert werden.',
    deleteReason: 'Begründung löschen',
    reasonForChange: 'Änderungsgrund',
    pointInTime: 'Zeitpunkt',
    automaticChange: 'Maschinelle Änderung',
    newValue: 'Neuer Wert',
    changesConfirmed: 'Änderung bestätigt',
    addNewIntervention: 'Neue Intervention anlegen',
    criterionFor: 'Kriterium zum',
    onlyOneEntryTooltip: 'Für diese Eigenschaft ist nur ein Eintrag zulässig',
    studyIdentifierDuplicate:
      'Die Studie mit dem angegebenen Identifier befindet sich bereits im Datenbestand.',
    infoAutoReceived: 'Informationen soweit möglich automatisch übernommen.',
    studyAdded: 'Studie hinzugefügt',
    studyNotFoundIdentifier:
      'Keine Studie mit dem angegebenen Identifier gefunden',
    appliedNewStatus: 'Neuer Status wurde übernommen.',
    studyValidated: 'Studie validiert',
    revokedValidation: 'Studie invalidiert',
    revalidationRequested: 'Erneute Validierung beantragt',
    unableToApplyStatus: 'Der neue Status konnte nicht übernommen werden.',
    deletionFailed: 'Löschen fehlgeschlagen',
    deletionFailedMsg: `"Studie konnte nicht gelöscht werden, weil sie von anderen Ressourcen referenziert wird. In der Regel handelt es sich dabei um Favoritenlisten."`,
    newInerventionNotProcessed:
      'Neue Intervention noch nicht vollständig verarbeitet',
    pleaseSelectNewIntervention: 'Bitte wählen Sie die neue Intervention',
    fromThisListIfNeeded:
      'bei Bedarf manuell aus der Liste der Interventionen aus.',
    mayNeedFewMinutes:
      'Es kann einige Minuten dauern, bis die neue Intervention in der Liste erscheint.',
    newIntervention: 'Neue Intervention',
    addedSuccessFully: 'erfolgreich hinzugefügt.',
    interventionAlreadyInList:
      'Intervention befindet sich bereits auf der Liste.',
    couldNotBeAdded: 'konnte nicht hinzugefügt werden. Grund',
    biomarkerIncomplete:
      'Fehlende Angaben bei den Biomarkern. Es wurden eventuell nicht alle Angaben gespeichert.',
    loading: 'Lädt...',
    changesSaved: 'Änderungen erfolgreich auf dem Server abgelegt.',
    notSaved:
      'Änderungen konnten nicht gespeichert werden. Bitte prüfen Sie Ihre Eingaben.',
    illegalStatusInputMsg:
      'Bitte wählen Sie einen Wert für den Rekrutierungsstatus aus',
    deleteStudyQuestion:
      'Wollen Sie die aktuell ausgewählte Studie wirklich löschen?',
    deleteStudyAlt:
      'Alternativ können Sie die Studie archivieren. Archivierte Studien werden nicht mehr in der regulären Liste angezeigt, können in  der Suche aber über den entsprechenden Filter gefunden werden.',
    hideStudyButton: 'Studie archivieren',
    studyHiddenExpl:
      'Archivierte Studien werden nicht mehr in der regulären Liste angezeigt, können in  der Suche aber über den entsprechenden Filter gefunden werden.',
    unableDeleteStudy: 'Studie konnte nicht gelöscht werden.',
    onlyOneIdentPerSystem:
      'Zu jedem System kann nur ein Identifier eingetragen werden. Zur Zeit werden die folgenden',
    systemsSupported: 'Systeme unterstützt',
    hideLastChanges: 'Letzte Änderungen ausblenden',
    showLastChanges: 'Letzte Änderungen anzeigen',
    noStudyFoundIdentifier:
      'Es konnte keine Studie mit dem gegebenen Identifier gefunden werden.',
    lastChangedMsg:
      'Der angezeigte Zeitpunk gibt an, zu welchem Zeitpunkt die letzte Änderung an diesem Datensatz in CATS (vom Update Algorithmus oder manuell) durchgeführt wurde. Dieser kann von Angaben externer Studiendatenbanken (z.B. Clinicaltrials.gov) abweichen, da dort ggf. andere Datenfelder geändert wurden, welche nicht von CATS ausgelesen werden. CATS wird periodisch automatisiert aktualisiert.',
    contactInfoMsg:
      'Diese Kontaktdaten werden automatisch aus den Datenquellen erhoben und können aktuell nicht bearbeitet werden.',
    studyCreated: 'Studie erstellt',
    creationCancel: 'Abbrechen',
    changeRequestModal: {
      proposeStatusChange: 'Anderen Status vorschlagen',
      changeRequestModalTitle: 'Änderung vorschlagen',
      sendChangeRequest: 'Änderungsvorschlag senden',
      sendChangeRequestForNewEntry: 'Vorschlag für neuen Eintrag senden',
      changeRequestModalText:
        'Bitte geben Sie die vorgeschlagenen Änderungen ein und nennen Sie idealerweise einen Grund für den Änderungsvorschlag.',
      changeRequestModalChangeInput: 'Vorschlag',
      reasonPlaceholder: 'Änderungsgrund',
      changeRequestModalReasonInput: 'Begründung',
      originalValue: 'Bisheriger Wert',
      proposeDeletion: 'Löschung vorschlagen',
      newSite: 'Neue Einrichtung',
      briefTitle: 'Kurztitel',
      title: 'Titel',
    },
    variantEdit: {
      proteinExchangeInputPlaceholder: 'Protein Exchange Code',
      submitBtnText: 'Suche',
      gene: 'Gen',
      proteinChange: 'Protein change',
    },
    showChangeRequests: 'Offene Änderungsvorschläge',
    changeRequestObsoleteMessage:
      'Der ausgewählte Änderungsvorschlag betrifft Informationen, die nicht (mehr) gefunden werden können. Bitte überprüfen Sie, ob er tatsächlich nicht mehr relevant ist und verwerfen Sie ihn in diesem Fall.',
    cancelRequest: 'Vorschlag verwerfen',
  },
  locationCreation: {
    newFacility: 'Neue Einrichtung',
    enterFacilityData: 'Bitte geben Sie die Daten für die neue Einrichtung ein',
    addFacilityCautionMsg: `Bevor Sie eine neue Einrichtung erstellen vergewissern Sie sich
    bitte, dass diese nicht bereits existiert. Verwenden Sie hierzu
    die Möglichkeit zur Suche im regulären Eingabefeld für
    Einrichtungen.`,
    addFacilitySimilarFound: `Es wurden ähnliche Einträge in der Datenbank gefunden. Falls
    einer davon der gewünschten Einrichtung entspricht, bitte diesen auswählen.`,
    noAddressDetails: 'Keine Adressdetails',
    useExistingFacility: 'Bestehende Einrichtung übernehmen',
    chooseSimilarFacilityTooltip: `Bitte wählen Sie eine bestehende Einrichtung aus, um diese
    zur Studie hinzufügen zu können.`,
    chooseSimilarFacilityTooltipConfirmation: `Ausgewähle Einrichtung anstelle Ihrer Eingaben zur Studie
    hinzufügen`,
    createNewFacility: 'Neue Einrichtung erstellen',
    createNewFacilityTooltip:
      'Neue Einrichtung mit Ihren Eingaben erstellen und zur Studie hinzufügen',
    saveAndNewLocation: 'Speichern und weitere erstellen',
    saveAndClose: 'Speichern und schließen',
    successToastTitle: 'Einrichtung erstellt',
    successToastMsg: 'Neue Einrichtung erfolgreich in der Datenbank angelegt.',
    failToastMsg:
      'Die Einrichtung konnte nicht erstellt werden. Überprüfen Sie bitte ihre Angaben und versuchen Sie es erneut.',
  },
  share: {
    shareSearch: 'Suche teilen',
    sendMail: 'Email senden',
    copyLink: 'Link kopieren',
    urlTooLongTooltip:
      'Zu viele Filterparameter für automatisches Teilen via Email. Zum Teilen bitte die url über nebenstehende Schaltfläche kopieren und manuell in eine Email kopieren.',
  },
  token: {
    copyToken: 'Token kopieren',
    copyTokenMsgTitle: 'Token kopiert',
    copyTokenMsg: 'Keykloak token in die Zwischenablage kopiert',
  },
  cookieBanner: {
    infoMsg:
      'Diese Website verwendet Cookies - Nähere Informationen dazu finden Sie in unserer Datenschutzerklärung. Klicken Sie auf "zustimmen", um alle Cookies zu aktivieren oder auf "ablehnen", um alle nicht zum Betrieb dieser Seite unbedingt notwendigen Cookies abzulehnen.',
    acceptBtn: 'Akzeptieren',
    declineBtn: 'Ablehnen',
    privacyBtn: 'Datenschutzerklärung',
  },
  contactDetails: {
    name: 'Name',
    phone: 'Telefon',
    email: 'Email',
    contactPossibility: 'Kontaktmöglichkeit',
    contactInformation: 'Kontaktinformationen',
    noDetails: 'Keine Kontaktinformationen vorhanden',
    source: 'Quelle',
    unknown: 'Unbekannt',
    edit: {
      telecomSelectPlaceholder: 'Kategorie',
      addInfoHint: 'Hier klicken um Kontaktinformationen hinzuzufügen',
    },
    contactDetailEdit: {
      tooltips: {
        removeTelecom: 'Kontaktmöglichkeit (z.B. Telefon, Email) entfernen',
        addTelecom: 'Kontaktmöglichkeit (z.B. Telefon, Email) hinzufügen',
        addContactDetail: 'Kontakt hinzufügen',
        removeContactDetail: 'Kontakt entfernen',
      },
      invalidContactPhoneInputMsg:
        'Die eingegebene Telefonnummer ist ungültig. Bitte verwenden Sie nur Ziffern und gängige Sonderzeichen.',
      invalidContactMailInputMsg:
        "{ 'Die eingegebene E-Mail ist ungültig. Erwartetes Format: name@beispiel.suffix' }",
      emptyContactPhoneMsg: 'Bitte geben Sie eine Telefonnummer ein.',
      emptyContactMailMsg: 'Bitte geben Sie eine E-Mail Adresse ein.',
    },
    originTranslation: {
      catsFrontend: 'Manuell via CATS-Frontend hinzugefügt',
    },
  },
  tumorcategories: { solidTumors: 'Solide Tumore' },
  error: {
    failedToLoadResource: 'Ressource konnte nicht geladen werden',
    copyClipboardError: 'Beim Kopieren ist ein Fehler aufgetreten',
    notWorked: 'Das hat nicht funktioniert',
    changeRequestCouldNotBeLoaded:
      'Änderungsvorschlag konnte nicht geladen werden',
    alreadyExists: 'Exisitert bereits',
    error: 'Fehler',
    errorDuringRequest: 'Bei der Anfrage ist ein Fehler aufgetreten.',
    errorOccurred: 'Es ist ein Problem aufgetreten',
    geolocationFailedMsg:
      'Die Koordinaten konnten nicht ermittelt werden. Bitte in wenigen Minuten erneut versuchen.',
    geolocationFailedCoordinatesDeliveryMsg:
      'Die nötigen Koordinaten für die Umkreissuche konnten nicht ermittelt werden.',
    couldNotRemoveStudyFromFavs:
      'Studie konnte nicht aus Favoriten entfernt werden',
    couldNotAddStudyToFavs:
      'Studie konnte nicht zu Favoriten hinzugefügt werden',
    // warningOccurred: "Warnung",
    // unauthorized: "Sie sind nicht berechtigt, diese Operation durchzuführen.",
    // pageNotFound: "Seite nicht gefunden",
    // pageNotFoundDescription: "Die angeforderte Seite konnte nicht gefunden werden. Bitte stellen Sie sicher, dass die Adresse korrekt ist."
  },
  changeRequestPage: {
    change: 'Änderung',
    tasks: 'Vorschläge',
    heading: 'Änderungsvorschläge',
    userSpecificHeading: 'Meine Änderungsvorschläge',
    noEntries: 'Keine offenen Änderungsvorschläge gefunden',
    requested: 'Vorgeschlagen',
    cancelled: 'Verworfen',
    completed: 'Übernommen',
    filterForStatus: 'Nach Status filtern',
    confirmTaskCancellationModalMsg:
      'Ausgewählten Änderungsvorschlag verwerfen?',
    lastUpdated: 'Letzte Änderung ',
    status: 'Status',
    changedInfoType: 'Betroffene Information',
    oldValue: 'Ursprünglicher Wert',
    newValue: 'Vorgeschlagener Wert',
    changeReason: 'Grund',
    options: 'Optionen',
    studyTitle: 'Studientitel',
    targetTitlePlaceholder: 'Nicht verfügbar',
    changeRequestTaskStatusTranslations: {
      requested: 'Vorgeschlagen',
      completed: 'Übernommen',
      cancelled: 'Verworfen',
    },
    affectedFields: {
      site: 'Einrichtung',
      'site status': 'Einrichtungsstatus',
      contact: 'Kontakt',
      status: 'Rekrutierungsstatus',
      title: 'Titel',
      'brief title': 'Kurztitel',
    },
    toasts: {
      cancelFailure: {
        title: 'Statusänderung fehlgeschlagen',
        message: 'Änderungsvorschlag konnte nicht verworfen werden.',
      },
      cancelSuccess: {
        title: 'Statusänderung erfolgreich',
        message: 'Änderungsvorschlag wurde als verworfen markiert.',
      },
      reActivationSuccess: {
        title: 'Statusänderung erfolgreich',
        message: 'Änderungsvorschlag wurde reaktiviert.',
      },
      reActivationFailure: {
        title: 'Statusänderung fehlgeschlagen',
        message: 'Änderungsvorschlag konnte reaktiviert werden.',
      },
      openError: {
        generalErrorMsg: 'Da ist etwas schief gelaufen',
        couldNotOpenStudyWithRequest:
          'Die Studienseite mit weiteren Informationen zum Änderungsvorschlag konnte nicht geöffnet werden',
      },
    },
    tooltips: {
      reActivateTask: 'Vorschlag reaktivieren',
      cancelTask: 'Vorschlag verwerfen',
      requestNotActiveMsg:
        'Änderungsvorschlag ist nicht mehr aktiv und kann nicht geöffnet werden.',
      newEntry: 'Neuer Eintrag',
      removal: 'Löschung',
      change: 'Änderung',
    },
  },
  genericConfirmationModal: {
    header: 'Bestätigung erforderlich',
  },
  changeRequestComponents: {
    modalOpenerTooltips: {
      add: 'Neuen Eintrag vorschlagen',
      change: 'Änderung vorschlagen',
    },
    valueToBeAdded: 'Neu hinzuzufügen:',
    proposedDeletion: 'Entfernung vorgeschlagen',
    proposedChange: 'Vorgeschlagene Änderung',
    changeRequest: 'Änderungsvorschlag',
    accept: 'Änderungen übernehmen',
    reject: 'Änderungen ablehnen',
    valueAtTimeOfRequestCreation: 'Ursprünglicher Wert',
    suggestedValue: 'Vorgeschlagener Wert',
    reason: 'Grund',
    timeOfRequest: 'Zeitpunkt',
    changedTargetWarning: {
      targetValueChanged:
        'Ursprünglicher Wert wurde seit Änderungsvorschlag verändert',
      currentValue: 'Aktueller Wert',
    },
  },
  substanceCreationModal: {
    title: 'Neue Intervention anlegen',
    message:
      'Existiert die gewünschte Intervention nicht in der Auswahl, kann diese hier neu angelegt werden.\nBitte den Namen der neuen Intervention eingeben. Die Groß-/Kleinschreibung wird u.U. an Systemstandards angepasst.',
    placeholder: 'Name der gewünschten Intervention',
    confirm: 'Übernehmen',
    cancel: 'Abbrechen',
    inputLabel: 'Name',
    infoMessage:
      'Achtung: Interventionen müssen großgeschrieben werden, dies wird bei Erstellung automatisch angepasst.',
  },
  changeRequestFeedbackToasts: {
    taskCreated: {
      title: 'Änderungsvorschlag registriert',
      message:
        'Ihr Änderungsvorschlag wurde erfolgreich eingereicht und wird zur Prüfung weitergeleitet.\nVielen Dank für Ihre Mitwirkung.',
    },
    taskCreationFailed: {
      title: 'Änderungsvorschlag nicht gespeichert',
      message: 'Änderungsvorschlag konnte nicht gespeichert werden',
    },
  },
  pwaInstallPrompt: {
    title: 'Zu Desktop hinzufügen',
    message:
      'CATS kann installiert und dann wie eine reguläre App vom Desktop aus gestartet werden. Sie müssen dann nicht mehr den Browser benutzen.',
    acceptBtn: 'Installieren',
    declineBtn: 'Ablehnen und nicht erneut anzeigen',
  },
  pwaUpdatePrompt: {
    message:
      'Eine neue Version von CATS ist verfügbar.\n\nUpdate jetzt durchführen (dies wird alle offenen Tabs der Anwendung neu laden und dadurch nicht gespeicherte Eingaben löschen)?\nSollte das Update jetzt nicht durchgeführt werden, wird diese Nachricht beim nächsten Laden der Seite erneut angezeigt.',
  },
  fallbackPage: {
    title: 'Da ist wohl etwas schief gelaufen...',
    errorAnouncement: 'Der folgende Fehler ist aufgetreten',
    followingOptions: 'Was Sie tun können',
    checkInternetConnection: 'Überprüfen Sie Ihre Internetverbindung',
    refreshPage:
      'Laden Sie die Seite neu. Versuchen Sie ggf. einen Hard Reload: Das kann z.B. mit Shift + Klick auf den "Neu laden"-Button erreicht werden, abhängig vom Browser.',
    tryAgain: 'Versuchen Sie es (ggf. später) erneut',
    tryDifferentBrowser: 'Versuchen Sie es mit einem anderen Browser',
    contactSupportMail:
      'Falls keine der obigen Optionen zum Erfolg führt, wenden Sie sich gern an',
    reopenBrowser:
      'Schließen Sie den Browser und öffnen Sie ihn erneut, um die Seite neu zu laden',
  },
  sidebar: {
    filterOptions: 'Filteroptionen',
    tableColumnSelection: 'Tabellenansicht',
    collapse: 'Zuklappen',
    titleFormat: 'Titeldarstellung',
  },
  biomarkerPopup: {
    modalTitle: 'Wählen Sie Biomarker und ihre Ausprägung als Filter aus',
    cancel: 'Abbrechen',
    apply: 'Anwenden',
    positive: 'Positiv',
    negative: 'Negativ',
    unknown: 'Unbekannt',
    notTested: 'Nicht getestet',
  },
  LoincLL36393Answers: {
    'LA6576-8': 'Positiv',
    'LA6577-6': 'Negativ',
    'LA4489-6': 'Unbekannt',
    'LA13538-6': 'Nicht getestet',
  },
  collapse: {
    showMore: 'Mehr anzeigen',
    showLess: 'Weniger anzeigen',
  },
};

export default messages;
